<mat-drawer-container class="example-container" autosize>
    <mat-drawer #historyDrawer class="example-sidenav" mode="side" position="end">
        <mat-card>
            <mat-card-header>
                <div mat-card-avatar class="mat-card-header-text">
                    <div class="material-symbols-outlined" style="font-size: 24pt;float-left;">
                        history
                    </div>
                </div>
                <mat-card-title>History</mat-card-title>
                <mat-card-subtitle>Edit History</mat-card-subtitle>
            </mat-card-header>
            <mat-vertical-stepper [linear]="false" #stepper>
                <mat-step *ngFor="let editHistory of editHistorys">
                    <ng-template matStepLabel>{{editHistory.EventDateTime}}</ng-template>
                    <mat-chip>{{editHistory.EventType}}</mat-chip>
                    <mat-chip>{{editHistory.EventUser}}</mat-chip>
                </mat-step>
            </mat-vertical-stepper>
            <mat-card-content>
            </mat-card-content>
            <mat-card-actions>
            </mat-card-actions>
        </mat-card>
    </mat-drawer>
    <mat-card>
        <mat-card-header>
            <div mat-card-avatar class="mat-card-header-text">
                <div class="material-symbols-outlined" style="font-size: 24pt;float-left;">
                    person
                </div>
            </div>
            <mat-card-title>{{itemData.FirstName}} {{itemData.LastName}}</mat-card-title>
            <mat-card-subtitle>User: Id-{{itemId}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form *ngIf="itemData">
                <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                    <mat-label>Email</mat-label>
                    <input matInput #emailAddress maxlength="256" [(ngModel)]="itemData.Email" width="220" name="Email" />
                </mat-form-field>
                <br />
                <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                    <mat-label>First Name</mat-label>
                    <input matInput #firstName maxlength="256" [(ngModel)]="itemData.FirstName" width="220" name="FirstName" />
                </mat-form-field>
                <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                    <mat-label>Last Name</mat-label>
                    <input matInput #lastName maxlength="256" [(ngModel)]="itemData.LastName" width="220" name="LastName" />
                </mat-form-field>
                <br />                
                <div class="flex gap-3">
                    <div>
                        <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                            <mat-label>Password</mat-label>
                            <input matInput #password type="password" [(ngModel)]="itemData.Password" width="220" name="Password" />
                            <mat-icon matSuffix class="material-symbols-outlined" (click)="showPasswordEditHint()" style="font-size: 14pt;">help</mat-icon>
                        </mat-form-field>
                    </div>
                    <div class="card">
                        <password-rule [isPass]="mustContainLetters()" rule="Must contain a letter"/>
                        <password-rule [isPass]="mustContainNumber()" rule="Must contain a number"/>
                        <password-rule [isPass]="mustContainUpperCase()" rule="Must contain upper case"/>
                        <password-rule [isPass]="mustContainLowerCase()" rule="Must contain lower case"/>
                        <password-rule [isPass]="mustContainSpecialCharacter()" rule="Must contain special character"/>
                        <password-rule [isPass]="mustBeAtLeast8Characters()" rule="Must contain at least 8 characters"/>
                    </div>
                </div>
            </form>
            <mat-tab-group *ngIf="itemId != '0'" mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span matBadge="{{this.itemData.Roles.length == 0 ? '' : this.itemData.Roles.length}}" matBadgeSize="small" matBadgeOverlap="false">
                            Roles
                        </span>
                    </ng-template>
                    <br />
                    <form>
                        <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                            <mat-label>Available Roles</mat-label>
                            <mat-select [formControl]="rolesTabFormControl" [(ngModel)]="selectedRole">
                                <mat-option *ngFor="let role of availableRoles" [value]="role">{{role.Name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <button mat-button (click)="addRole()" [disabled]="this.selectedRole == null">
                            <span class="material-symbols-outlined">
                                add
                            </span>
                            ADD ROLE
                        </button>
                    </form>
                    <br />
                    <table mat-table matSort #roleSort="matSort" [dataSource]="resultsRolesMatTableDataSource" class="mat-elevation-z8 {{rolesResultsClass}}">
                        <ng-container matColumnDef="Avatar">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let item" (click)="editRole(item)">
                                <span class="material-symbols-outlined" style="font-size: 18pt;">
                                    work
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="RoleName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> RoleName </th>
                            <td mat-cell *matCellDef="let item" (click)="editRole(item)"> {{item.Name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="RemoveRole">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let item" (click)="removeRole(item)">
                                <span class="material-symbols-outlined" style="font-size: 18pt;">
                                    delete
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedRolesColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedRolesColumns;"></tr>
                    </table>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label>
                        <span matBadge="{{this.itemData.Claims.length == 0 ? '' : this.itemData.Claims.length}}" matBadgeSize="small" matBadgeOverlap="false">
                            Claims
                        </span>
                    </ng-template>
                    <br />
                    <form>
                        <mat-form-field class="" style="width: 220px; padding-left: 12px;">
                            <mat-label>Claim Type</mat-label>
                            <input matInput #firstName maxlength="256" [(ngModel)]="enteredClaimType" width="220" name="EnteredClaimType" />
                        </mat-form-field>
                        <mat-form-field style="width: 220px; padding-left: 12px;">
                            <mat-label>Claim Value</mat-label>
                            <input matInput #lastName maxlength="256" [(ngModel)]="enteredClaimValue" width="220" name="EnteredClaimValue" />
                        </mat-form-field>
                        <button mat-button (click)="addClaim()" [disabled]="this.enteredClaimType.trim() == '' || this.enteredClaimValue.trim() == ''">
                            <span class="material-symbols-outlined">
                                add
                            </span>
                            ADD CLAIM
                        </button>
                    </form>
                    <br />
                    <table mat-table matSort #claimSort="matSort" [dataSource]="resultsClaimsMatTableDataSource" class="mat-elevation-z8 {{claimsResultsClass}}">
                        <ng-container matColumnDef="Avatar">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let item" (click)="editClaim(item)">
                                <span class="material-symbols-outlined" style="font-size: 18pt;">
                                    interests
                                </span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                            <td mat-cell *matCellDef="let item" (click)="editClaim(item)"> {{item.Type}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Value">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
                            <td mat-cell *matCellDef="let item" (click)="editClaim(item)"> {{item.Value}} </td>
                        </ng-container>
                        <ng-container matColumnDef="Issuer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Issuer </th>
                            <td mat-cell *matCellDef="let item" (click)="editClaim(item)"> {{item.Issuer}} </td>
                        </ng-container>
                        <ng-container matColumnDef="RemoveClaim">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let item" (click)="removeClaim(item)">
                                <span class="material-symbols-outlined" style="font-size: 18pt;">
                                    delete
                                </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedClaimsColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedClaimsColumns;"></tr>
                    </table>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-actions>
            <button mat-button (click)="onClickSave()">
                <span class="material-symbols-outlined">
                    save
                </span>
                SAVE
            </button>
            <button *ngIf="itemId != '0'" mat-button (click)="delete()">
                <span class="material-symbols-outlined">
                    delete_forever
                </span>
                DELETE
            </button>
            <button *ngIf="itemId != '0'" mat-button (click)="historyDrawer.toggle()">
                <span class="material-symbols-outlined">
                    history
                </span>
                CHANGE LOG
            </button>
        </mat-card-actions>
        <mat-card-footer>
            <!--<mat-progress-bar mode="indeterminate"></mat-progress-bar>-->
        </mat-card-footer>
    </mat-card>
</mat-drawer-container>
